<template>
  <fanzone-form
    :id='id'
    redirectTo='/#/fanzones-roadtours'
    label='Trasy koncertowe'
    :idStepsEvent='false'
    :idsRelatedEvents='true'
    :scenesEditor='false'
  />
</template>

<script>
	import fanzoneForm from '../components/FanzoneForm'
	
	export default {
    props: ['id'],
    components: { fanzoneForm },
	}
</script>
